import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Webcam = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M14.009 15.431c-.062 0-.124-.005-.184-.016l-5.826-1.06-5.825 1.06a1 1 0 0 1-1.036-1.5l2.066-3.446a.334.334 0 0 1 .572.343l-2.067 3.446a.334.334 0 0 0 .346.5l5.885-1.07a.332.332 0 0 1 .12 0l5.884 1.07a.333.333 0 0 0 .346-.5l-2.067-3.446a.336.336 0 0 1 .018-.37.335.335 0 0 1 .466-.07.333.333 0 0 1 .088.097l2.066 3.446a1 1 0 0 1-.852 1.515v.001Z" />
      <path d="M8 .352a6.331 6.331 0 1 1-5.25 9.866A6.333 6.333 0 0 1 5.533.85C6.313.52 7.153.35 8 .352Zm0 12a5.667 5.667 0 1 0-4.007-1.66A5.629 5.629 0 0 0 8 12.351Z" />
      <path d="M7.999 3.686a3.667 3.667 0 1 1 0 7.333 3.667 3.667 0 0 1 0-7.333Zm0 6.666a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M7.999 8.019a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
    </svg>
  );
};

Webcam.category = 'product-category';

Webcam.displayName = 'Webcam';
